import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Login } from "./pages/login";
import { PayDonationAmount } from "./pages/payDonationAmount";
import { SelectDonationAmount } from "./pages/selectDonationAmount";
import VarniConfirmReceiptNeeded from "./pages/varni/varniConfirmReceiptNeeded";
import { VarniLogin } from "./pages/varni/varniLogin";
import { VarniPayDonationAmount } from "./pages/varni/varniPayDonationAmount";
import { VarniSelectDonationAmount } from "./pages/varni/varniSelectDonationAmount";
import VarniAcquireDonorDetails from "./pages/varni/varniAcquireDonorDetails";

export const Login_Path = "/login";
export const Varni_Login_Path = "/varni-login";
export const Select_Donation_Amount_Path = "/select-donation-amount";
export const Varni_Select_Donation_Amount_Path = "/varni-select-donation-amount";

export default function ApplicationRoutes() {

    return (<BrowserRouter  basename='/kiosk'>
        <Routes>
            <Route index path={Login_Path} element={<Login />} />
            <Route index path={Varni_Login_Path} element={<VarniLogin />} />
            <Route path={Select_Donation_Amount_Path} element={<SelectDonationAmount />} />
            <Route path={Varni_Select_Donation_Amount_Path} element={<VarniSelectDonationAmount />} />
            <Route path="/pay" element={<PayDonationAmount />} />
            <Route path="/varni-pay" element={<VarniPayDonationAmount />} />
            <Route path="/varni-confirm-receipt-needed" element={<VarniConfirmReceiptNeeded />} />
            <Route path="/varni-acquire-donor-details" element={<VarniAcquireDonorDetails/>} />
        </Routes>
    </BrowserRouter>)
}